export default __webpack_public_path__ + "static/media/SWT0130.34I-35650_-21672_0.aa59331e.jpg";